import { css } from 'styled-components';

export default css`
  ${['top', 'right', 'bottom', 'left'].map(
    (direction) => css`
      [class*='rc-tooltip-placement-${direction}'] .rc-tooltip-arrow {
        border-${direction}-color: ${({ theme }) => theme.colors.black} !important;
      }
    `
  )}
`;
